import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { ButtonResponsiveProps, getResponsiveButtonProps } from '@framework/ui';
import { useMemo } from 'react';

interface Props {
  ignoreMobile: boolean | undefined;
  buttonText: string;
  forceIcon: boolean | undefined;
  inline?: boolean | undefined;
  isMobile: boolean | null;
  hasInlineViewer: boolean;
}

/**
 * Hook per la definizione delle props responsive per i pulsanti
 * per il download del pdf del modulo/richiesta
 */
export function useButtonResponsiveProps(props: Props) {
  const {
    ignoreMobile,
    buttonText,
    forceIcon,
    isMobile,
    hasInlineViewer,
    inline,
  } = props;

  const buttonResponsiveProps = useMemo(() => {
    return getResponsiveButtonProps(
      {
        ignoreMobile: ignoreMobile,
        iconLeftAriaLabel: buttonText,
        iconLeftComponent:
          forceIcon ?? inline ?? isMobile
            ? hasInlineViewer
              ? EyeOutlined
              : DownloadOutlined
            : undefined,
        text: buttonText,
      } satisfies ButtonResponsiveProps,
      isMobile,
    );
  }, [ignoreMobile, buttonText, forceIcon, inline, isMobile, hasInlineViewer]);

  return buttonResponsiveProps;
}
